import { ReactNode, useState } from 'react'
import { Button } from '@systemeio/components'
import { useTranslation } from 'next-i18next'
import Image from 'next/image'

interface ResubscribedCardProps {
  onConfirmResubscribed?: () => void
  isFetching?: boolean
  title: string
  subTitle: string
}

function ResubscribedCard({
  subTitle,
  onConfirmResubscribed,
  isFetching,
  title,
}: ResubscribedCardProps): ReactNode {
  const { t } = useTranslation()
  const [isSuccess, setIsSuccess] = useState(false)

  function confirmResubscribed(): void {
    onConfirmResubscribed?.()
    setIsSuccess(true)
  }

  return (
    <>
      <Image
        src="/images/unsubscribed.png"
        alt={t('mailing.unsubscribe_page.unsubscribed_success.title')}
        height={149}
        width={180}
      />
      {isSuccess ? (
        <span className="mt-4">{t('mailing.resubscribe.success_message')}</span>
      ) : (
        <>
          <h1 className="mb-8">{title}</h1>
          <span className="mb-8">{subTitle}</span>
          <div className="flex w-full justify-center gap-4">
            <Button
              variant="primary"
              className="w-full whitespace-normal"
              isLoading={isFetching}
              onClick={async e => {
                e.preventDefault()
                await confirmResubscribed()
              }}
              type="submit"
            >
              {t('mailing.resubscribe_to_prev_subscriptions')}
            </Button>
          </div>
        </>
      )}
    </>
  )
}

export default ResubscribedCard
